import api from '../api-methods'

const proxyApi = process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API
const proxyHr = process.env.VUE_APP_ENV === 'local' ? '/proxy_hr' : process.env.VUE_APP_API_HR

const global = {
  iosReview: payload => {
    return api.get(proxyApi + '/v3/ios_review', payload)
  },
  getGioData: token => {
    return api.get(proxyApi + `/v3/cv_accounts/${token}/gio_data`)
  },
  messageTrack: payload => {
    return api.post(proxyApi + '/v3/message_track', payload)
  },
  orderPay: (token, payload) => {
    return api.post(proxyApi + `/v3/orders/improved_orders/${token}/pay`, payload)
  },
  mentorOrderPay: (token, payload) => {
    return api.post(proxyApi + `/v3/orders/mentor_orders/${token}/pay`, payload)
  },
  bJobOrderPay: (token, payload) => {
    return api.post(proxyHr + `/v1/job_orders/${token}/pay`, payload)
  },
  // 创建购买证件照订单
  createPhotoBeautyOrder: (payload) => {
    return api.post(proxyApi + `/v3/orders/id_photo_orders`, payload)
  },
  // 获取落地页信息
  getLandingPageData: payload => {
    return api.get(proxyApi + `/v3/landing_pages/message`, payload)
  },
  //更新订单状态
  updateOrderStatus: payload => {
    return api.put(proxyHr + '/v1/job_orders', payload)
  }
   
}

export default global
